import styled from 'styled-components';

import UnauthenticatedLayout from '../../../overwrites/views/layouts/UnauthenticatedLayout/UnauthenticatedLayout';
import { MainButton } from '../auth.styles';

export const ConfirmButton = styled(MainButton).attrs((props) => ({
  ...props,
  css: {
    ...props.css,
    '&&': {
      ...props.css?.['&&'],
      marginTop: '$5',
      marginBottom: '$8',
    },
  },
}))``;

export const StyledUnauthenticatedLayout = styled(UnauthenticatedLayout).attrs((props) => ({
  ...props,
  pageContainerMaxWidth: '26rem',
}))``;
